export const EQUIPMENT_CLASSIFICATIONS = [
  "Compressor",
  "VRU Compressor",
  "Flare",
  "Tank",
  "Heater Treater",
  "LACT",
  "Pump",
  "Separator",
];

export const SOURCES = [
  "Connector",
  "Blowdown",
  "Pressure Relieve Device",
  "Open-ended line",
  "Flange",
  "Cover",
  "CVS",
  "Thief hatch",
  "Instrument",
  "Meter",
  "Yard piping",
  "Valve",
  "Control valve/Controller",
  "Compressor rod packing",
  "Compressor engine crankcase vent",
  "Compressor engine exhaust",
];

export enum EmissionTypeEnum {
  NORMAL = "Normal",
  FUGITIVE = "Fugitive",
}

export const EMISSION_TYPES = Object.values(EmissionTypeEnum);

export const DEFAULT_EMISSION_TYPE = EmissionTypeEnum.FUGITIVE;
